import * as React from "react";
import {OnFailure, OnSuccess} from "../../../../../store/action/actionHelpers";
import Toast from "../../../../helper/Toast";
import {BillOfMaterialsPreviewAsset} from "../../../../../model/job/BillOfMaterialsPreviewItems";
import BillOfMaterialsAssetFormView from "./BillOfMaterialsAssetFormView";
import {notifyBugsnagAndShowToast} from "../../../../../utils/Utils";
import {Dispatch} from "redux";
import {updateBillOfMaterialsAsset} from "../../../../../store/action/billOfMaterials/billOfMaterials";
import {connect} from "react-redux";
import {CreateUpdateBillOfMaterialsPreviewAssetApiDto} from "../../../../../api/model/rest";
import {BomItem} from "../../../../../model/job/BomItems";

interface IComponentProps {
	/**
	 * On submit form
	 */
	onSuccess: () => void;
	/**
	 * On cancel form
	 */
	onCancel: () => void;
	/**
	 * Bill of materials id
	 */
	bomDetailsId: string;
	/**
	 * Bill of Materials asset object
	 */
	bomAsset: BomItem;
	/**
	 * Job id
	 */
	jobId: string;
}

interface DispatchProps {
	/**
	 */
	updateBillOfMaterialsAsset: (bomId: string, assetId: string, bomAsset: CreateUpdateBillOfMaterialsPreviewAssetApiDto,
		jobId: string, onSuccess: OnSuccess, onFailure: OnFailure) => void
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}

type Props = IComponentProps & DispatchProps;

class BillOfMaterialsAssetFormComponent extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {isSubmitting: false};
		this.onSubmit = this.onSubmit.bind(this);
		this.onSubmitSuccess = this.onSubmitSuccess.bind(this);
		this.onSubmitFailure = this.onSubmitFailure.bind(this);
	}

	render() {
		return (
			<BillOfMaterialsAssetFormView onSubmit={this.onSubmit}
										  onCancel={this.props.onCancel}
										  isSubmitting={this.state.isSubmitting}
										  bomAsset={this.props.bomAsset}/>
		)
	}

	onSubmit(editedBOMAsset: BomItem) {
		this.setState({isSubmitting: true}, () => {
			const bomAssetToSubmit = editedBOMAsset.copy({id: this.props.bomAsset.id});
			this.updateBOMAsset(bomAssetToSubmit, this.onSubmitSuccess, this.onSubmitFailure);
		});
	}

	updateBOMAsset(bomAsset: BomItem, onSuccess: OnSuccess, onFailure: OnFailure) {
		this.props.updateBillOfMaterialsAsset(this.props.bomDetailsId, bomAsset.id, bomAsset.toJson(),
			this.props.jobId, onSuccess, onFailure);
	}

	onSubmitSuccess() {
		this.setState({isSubmitting: false}, () => {
			Toast.success("Bill of Materials asset updated", "Bill of Materials asset update");
			this.props.onSuccess();
		});
	}

	onSubmitFailure(error: any) {
		this.setState({isSubmitting: false}, () => notifyBugsnagAndShowToast(error, "Bill of Materials asset update failed"));
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		updateBillOfMaterialsAsset: (bomId: string, assetId: string, bomAsset: CreateUpdateBillOfMaterialsPreviewAssetApiDto,
			jobId: string, onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			updateBillOfMaterialsAsset(bomId, assetId, bomAsset, jobId, onSuccess, onFailure)
		)
	}
}

export default connect(null, mapDispatchToProps)(BillOfMaterialsAssetFormComponent);